import React from 'react';
import MagicWandIcon from '@bufferapp/ui/Icon/Icons/MagicWand';
import RefreshIcon from '@bufferapp/ui/Icon/Icons/Refresh';
import Tag from '@bufferapp/ui/Tag';
import { gray, grayDarker } from '@bufferapp/ui/style/colors';
import * as Tooltip from '@radix-ui/react-tooltip';

import { useAppSelector } from '~/store';
import { selectGenerateContentLimits } from '~/ai/state/aiLimits/slice';
import { getButtonClassNames } from '../helpers';

import * as Styled from './styles';

/**
 *
 */
const Button = ({
  label,
  loading,
  disabled,
  tryAgain,
}: {
  label: string;
  loading: boolean;
  disabled: boolean;
  tryAgain: boolean;
}) => {
  const { generateContentTokensLeft, limitsLoaded } = useAppSelector((state) =>
    selectGenerateContentLimits(state)
  );

  const classNames = limitsLoaded
    ? getButtonClassNames({
        tokensLeft: generateContentTokensLeft,
      })
    : [];

  const showArrow = !loading && !tryAgain;
  const Icon = tryAgain ? RefreshIcon : MagicWandIcon;

  return (
    <Tooltip.Provider>
      <Tooltip.Root delayDuration={0}>
        <Styled.StyledTooltipTrigger asChild>
          <Styled.StyledButton
            id="ai-assistant"
            color={loading ? gray : grayDarker}
            disabled={disabled}
            className={classNames.join(' ')}
            data-tokens={generateContentTokensLeft}
          >
            {loading ? <Styled.Loader /> : <Icon />}
            {tryAgain ? 'Try Again' : label}
            <Tag color="teal">Beta</Tag>
            {showArrow && <Styled.Arrow />}
          </Styled.StyledButton>
        </Styled.StyledTooltipTrigger>
        <Tooltip.Portal>
          {limitsLoaded && (
            <Styled.StyledTooltipContent
              data-state="instant-open"
              sideOffset={8}
            >
              {generateContentTokensLeft} AI credits available
            </Styled.StyledTooltipContent>
          )}
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export { Button };
